/**
 * LocalStorage keys used throughout the application
 * Centralized to ensure consistency and easy maintenance
 */
export const STORAGE_KEYS = {
  ACCESS_TOKEN: "orbit_access_token",
  USER: "orbit_user",
  USER_DETAILS: "orbit_user_details"
};
